(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroSection = document.getElementById('shopify-section-{{ section.id }}');
    if (!heroSection) return;

    const ensureVideoPlayback = (video) => {
      if (!(video instanceof HTMLVideoElement)) return;

      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      video.play().catch(() => {});
    };

    const videos = heroSection.querySelectorAll('.hero__media-grid video');
    videos.forEach((video) => {
      ensureVideoPlayback(video);
      video.addEventListener('loadeddata', () => ensureVideoPlayback(video));
      video.addEventListener('canplay', () => ensureVideoPlayback(video));
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) return;
      videos.forEach((video) => ensureVideoPlayback(video));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
